import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { EmailLogPage, EmailLogQuery } from './emails.types';

/** Admin email-log API: paginated outbound notification log + send summary. */
@Injectable({ providedIn: 'root' })
export class EmailsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/admin/emails`;

  /** One page of outbound emails, optionally filtered by category / status. */
  list(query: EmailLogQuery = {}): Observable<EmailLogPage> {
    let params = new HttpParams();
    if (query.page) params = params.set('page', query.page);
    if (query.page_size) params = params.set('page_size', query.page_size);
    if (query.category) params = params.set('category', query.category);
    if (query.status) params = params.set('status', query.status);
    return this.http.get<EmailLogPage>(`${this.base}/`, { params });
  }
}
